<ng-container [formGroup]="$any(controlContainer.control)">
    <wdx-form-field
        [locked]="formElement.isLocked"
        [label]="(formElement.label | translateTokenisedString) || ''"
        [guidanceText]="
            (formElement.guidanceText | translateTokenisedString) || ''
        "
        [isSensitive]="formElement.isSensitive ?? undefined"
        [isRequired]="formElement.isRequired ?? undefined"
        [labelForId]="inputId"
        [validationErrorMessage]="
            formControl?.touched
                ? (formControl?.errors
                  | validationErrorMessage
                      : formElement.fieldType
                      : (locale$ | ngrxPush))
                : ''
        "
        [warningMessage]="warningText"
    >
        @if (INPUT_GROUP_TYPES.includes($any(formElement.fieldType))) {
            <wdx-input-group
                [prefix]="!!formElement.prefix"
                [suffix]="!!formElement.suffix"
            >
                @if (formElement.prefix) {
                    <span prefix>{{ formElement.prefix }}</span>
                }

                @if (formElement.fieldType === FormFieldType.Text) {
                    <input
                        wdxInputText
                        type="text"
                        [formControlName]="$any(formElement.name)"
                        [attr.id]="inputId"
                        [attr.data-cy]="'input-' + formElement.name"
                        [attr.placeholder]="formElement.placeholder"
                        [attr.required]="formElement.isRequired"
                        [attr.maxlength]="formElement.max || 100"
                        [wdxUtilsDisabled]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement.pendingChange?.status)
                            )
                        "
                    />
                }

                @if (formElement.fieldType === FormFieldType.Integer) {
                    <input
                        wdxInputText
                        currencyMask
                        type="text"
                        inputmode="numeric"
                        [formControlName]="$any(formElement.name)"
                        [attr.id]="inputId"
                        [attr.data-cy]="'input-' + formElement.name"
                        [attr.placeholder]="formElement.placeholder"
                        [attr.required]="formElement.isRequired"
                        [wdxUtilsDisabled]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement.pendingChange?.status)
                            )
                        "
                        [options]="integerMaskNumberConfigOverride"
                    />
                }

                @if (formElement.fieldType === FormFieldType.Decimal) {
                    <input
                        wdxInputText
                        currencyMask
                        type="text"
                        inputmode="decimal"
                        [formControlName]="$any(formElement.name)"
                        [attr.id]="inputId"
                        [attr.data-cy]="'input-' + formElement.name"
                        [attr.placeholder]="formElement.placeholder"
                        [attr.required]="formElement.isRequired"
                        [wdxUtilsDisabled]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement.pendingChange?.status)
                            )
                        "
                        [options]="decimalMaskNumberConfigOverride"
                    />
                }

                @if (formElement.suffix) {
                    <span suffix>{{ formElement.suffix }}</span>
                }
            </wdx-input-group>
        }

        @if (formElement.fieldType === FormFieldType.Time) {
            <input
                wdxInputText
                wdxInputTime
                type="time"
                [formControlName]="$any(formElement.name)"
                [attr.id]="inputId"
                [attr.data-cy]="'input-' + formElement.name"
                [attr.placeholder]="formElement.placeholder"
                [attr.required]="formElement.isRequired"
                [wdxUtilsDisabled]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement.pendingChange?.status)
                    )
                "
            />
        }

        @if (formElement.fieldType === FormFieldType.Date) {
            <input
                wdxInputText
                wdxInputDate
                [type]="mapDateSpecificityType(formElement.dateSpecificityType)"
                [formControlName]="$any(formElement.name)"
                [attr.id]="inputId"
                [attr.data-cy]="'input-' + formElement.name"
                [attr.placeholder]="formElement.placeholder"
                [attr.required]="formElement.isRequired"
                [wdxUtilsDisabled]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement.pendingChange?.status)
                    )
                "
                (blur)="dateBlurEvent()"
            />
        }

        @if (formElement.fieldType === FormFieldType.DateTime) {
            <input
                type="datetime-local"
                wdxInputText
                wdxInputDate
                [formControlName]="$any(formElement.name)"
                [attr.id]="inputId"
                [attr.data-cy]="'input-' + formElement.name"
                [attr.placeholder]="formElement.placeholder"
                [attr.required]="formElement.isRequired"
                [wdxUtilsDisabled]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement.pendingChange?.status)
                    )
                "
                (blur)="dateBlurEvent()"
            />
        }

        @if (formElement.fieldType === FormFieldType.UrlLookup) {
            <div class="input-group">
                <div class="input-group-text">
                    <wdx-icon icon="globe"></wdx-icon>
                </div>
                <input
                    type="text"
                    wdxInputText
                    [attr.data-cy]="'input-' + formElement.name"
                    [placeholder]="formElement.placeholder"
                    [formControlName]="$any(formElement.name)"
                    [attr.required]="formElement.isRequired"
                    [wdxUtilsDisabled]="
                        isDisabled ||
                        PENDING_CHANGES_LOCK_FIELD.includes(
                            $any(formElement.pendingChange?.status)
                        )
                    "
                />
            </div>
        }

        @if (formElement.fieldType === FormFieldType.TextDropdown) {
            <ng-container [formGroupName]="$any(formElement.name)">
                <div class="input-group">
                    <input
                        type="text"
                        wdxInputText
                        formControlName="text"
                        [attr.data-cy]="'input-' + formElement.name"
                        [attr.required]="formElement.isRequired"
                        [wdxUtilsDisabled]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement.pendingChange?.status)
                            )
                        "
                    />
                    <ng-select
                        formControlName="dropdown"
                        bindLabel="label"
                        bindValue="value"
                        placeholder="Select"
                        [attr.data-cy]="'dropdown-' + formElement.name"
                        [items]="(options$ | ngrxPush) || []"
                        [readonly]="
                            isDisabled ||
                            PENDING_CHANGES_LOCK_FIELD.includes(
                                $any(formElement.pendingChange?.status)
                            )
                        "
                    ></ng-select>
                </div>
            </ng-container>
        }

        @if (formElement.fieldType === FormFieldType.MultilineText) {
            <textarea
                wdxInputText
                cols="30"
                [attr.rows]="formElement.lines || 4"
                [attr.data-cy]="'input-' + formElement.name"
                [formControlName]="$any(formElement.name)"
                [attr.id]="inputId"
                [attr.required]="formElement.isRequired"
                [attr.maxlength]="formElement.max"
                [wdxUtilsDisabled]="
                    isDisabled ||
                    PENDING_CHANGES_LOCK_FIELD.includes(
                        $any(formElement.pendingChange?.status)
                    )
                "
            ></textarea>
        }
    </wdx-form-field>
</ng-container>
